/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Quotes = NO -->*/
/*<!-- vale Google.Quotes = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1791331200000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Wed Oct 07 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "airship",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Airship",
          "depth": 0,
          "id": "connect-to-airship"
        }, {
          "value": "Basic Authentication",
          "depth": 1,
          "id": "basic-authentication"
        }, {
          "value": "Bearer Authentication",
          "depth": 1,
          "id": "bearer-authentication"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Named Users",
          "depth": 1,
          "id": "named-users"
        }, {
          "value": "Channels",
          "depth": 1,
          "id": "channels"
        }, {
          "value": "Send push notifications",
          "depth": 1,
          "id": "send-push-notifications"
        }, {
          "value": "Subscription Lists",
          "depth": 1,
          "id": "subscription-lists"
        }, {
          "value": "Send templated pushes",
          "depth": 1,
          "id": "send-templated-pushes"
        }, {
          "value": "Tags",
          "depth": 1,
          "id": "tags"
        }, {
          "value": "Static Lists",
          "depth": 1,
          "id": "static-lists"
        }, {
          "value": "Custom Events",
          "depth": 1,
          "id": "custom-events"
        }, {
          "value": "Attribute Lists",
          "depth": 1,
          "id": "attribute-lists"
        }, {
          "value": "Event streaming",
          "depth": 1,
          "id": "event-streaming"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Behavior and limitations",
          "depth": 1,
          "id": "behavior-and-limitations"
        }, {
          "value": "Validate your setup",
          "depth": 1,
          "id": "validate-your-setup"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      a: "a",
      strong: "strong",
      h3: "h3",
      ul: "ul",
      li: "li",
      h4: "h4",
      code: "code"
    }, _provideComponents(), props.components), {EventSyncWarning, NoCommonErrors, LiveDebugger, SyncAlerts} = _components;
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.p, {
        children: "Airship is a customer engagement platform for push notifications, in-app messages, email, and SMS. Hightouch syncs named users, channels, tags, subscription lists, static lists, attribute lists, and custom events from your warehouse to Airship, and sends pushes to Airship segments and named users. Marketers can then target and personalize Airship messages with warehouse data."
      }), "\n", _jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              align: "left",
              children: "Sync Type"
            }), _jsx(_components.th, {
              align: "left",
              children: "Description"
            }), _jsx(_components.th, {
              align: "left",
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              align: "left",
              children: "API Reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "#named-users",
                children: _jsx(_components.strong, {
                  children: "Named Users"
                })
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Create and update named users with tags and attributes"
            }), _jsx(_components.td, {
              align: "left",
              children: "Upsert, Update"
            }), _jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "https://www.airship.com/docs/developer/rest-api/ua/operations/named-users/#updatenameduser",
                children: "Create or update a named user →"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "#channels",
                children: _jsx(_components.strong, {
                  children: "Channels"
                })
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Update tags and attributes on existing channels"
            }), _jsx(_components.td, {
              align: "left",
              children: "Update"
            }), _jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "https://www.airship.com/docs/developer/rest-api/ua/operations/channels/",
                children: "Modify channel tags and attributes →"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "#send-push-notifications",
                children: _jsx(_components.strong, {
                  children: "Push Notification"
                })
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Send a push notification to an Airship segment"
            }), _jsx(_components.td, {
              align: "left",
              children: "Message"
            }), _jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "https://www.airship.com/docs/developer/rest-api/ua/operations/push/#sendpush",
                children: "Send a push →"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "#subscription-lists",
                children: _jsx(_components.strong, {
                  children: "Subscription Lists"
                })
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Subscribe and unsubscribe named users from subscription lists"
            }), _jsx(_components.td, {
              align: "left",
              children: "Add, Remove"
            }), _jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "https://www.airship.com/docs/developer/rest-api/ua/operations/named-users/#performnameduserscopedbatchoperations",
                children: "Update subscription lists →"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "#send-templated-pushes",
                children: _jsx(_components.strong, {
                  children: "Templated Push"
                })
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Send an Airship template as a push to each named user"
            }), _jsx(_components.td, {
              align: "left",
              children: "Insert"
            }), _jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "https://www.airship.com/docs/developer/rest-api/ua/schemas/platform-overrides-with-templates/",
                children: "Send a push with a template →"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "#tags",
                children: _jsx(_components.strong, {
                  children: "Tags"
                })
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Add and remove a tag on named users as they enter and leave the model"
            }), _jsx(_components.td, {
              align: "left",
              children: "Add, Remove"
            }), _jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "https://www.airship.com/docs/developer/rest-api/ua/operations/named-users/#modifynamedusertags",
                children: "Modify named user tags →"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "#static-lists",
                children: _jsx(_components.strong, {
                  children: "Static Lists"
                })
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Replace a static list with the named users in your model"
            }), _jsx(_components.td, {
              align: "left",
              children: "All"
            }), _jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "https://www.airship.com/docs/developer/rest-api/ua/operations/static-lists/#updatestaticlist",
                children: "Replace a static list →"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "#custom-events",
                children: _jsx(_components.strong, {
                  children: "Custom Events"
                })
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Send custom events for named users or channels"
            }), _jsx(_components.td, {
              align: "left",
              children: "Insert"
            }), _jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "https://www.airship.com/docs/developer/rest-api/ua/operations/custom-events/#addcustomevents",
                children: "Add custom events →"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "#attribute-lists",
                children: _jsx(_components.strong, {
                  children: "Attribute Lists"
                })
              })
            }), _jsx(_components.td, {
              align: "left",
              children: "Set attributes on named users in your model with an attribute list"
            }), _jsx(_components.td, {
              align: "left",
              children: "All"
            }), _jsx(_components.td, {
              align: "left",
              children: _jsx(_components.a, {
                href: "https://www.airship.com/docs/developer/rest-api/ua/operations/attribute-lists/#uploadattributelist",
                children: "Upload an attribute list →"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-airship",
        children: "Connect to Airship"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the ", _jsx(_components.strong, {
          children: "Cloud Site"
        }), " that hosts your Airship project: ", _jsx(_components.strong, {
          children: "North America"
        }), " or ", _jsx(_components.strong, {
          children: "Europe"
        }), ". See Airship's ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/developer/rest-api/ua/introduction/#servers",
          children: "servers"
        }), " docs for the URL each region uses."]
      }), "\n", _jsxs(_components.p, {
        children: ["Then authenticate with ", _jsx(_components.strong, {
          children: "Basic Authentication"
        }), " or ", _jsx(_components.strong, {
          children: "Bearer Authentication"
        }), ". Every sync type works with either method except ", _jsx(_components.strong, {
          children: "Custom Events"
        }), ", which requires ", _jsx(_components.strong, {
          children: "Bearer Authentication"
        }), " with the ", _jsx(_components.strong, {
          children: "App key"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Testing the connection checks access to named users, subscription lists, and pushes, plus custom events when a bearer destination has an ", _jsx(_components.strong, {
          children: "App key"
        }), ". It doesn't check static lists, attribute lists, templates, or tag groups."]
      }), "\n", _jsx(_components.h3, {
        id: "basic-authentication",
        children: "Basic Authentication"
      }), "\n", _jsx(_components.p, {
        children: "Enter these fields:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "APP Key"
          }), ": the app key that identifies your Airship project."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Secret"
          }), ": your project's master secret. Don't use the app secret. Airship limits the app secret to the endpoints its SDK needs, so pushes, static lists, and attribute lists fail with it."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["In Airship, select the dropdown menu next to your project name, then select ", _jsx(_components.strong, {
          children: "Project Details"
        }), " to find both values. Viewing the master secret requires the Owner or Administrator role. See Airship's ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/developer/rest-api/ua/api-security/#basic-auth",
          children: "Basic Auth"
        }), " docs."]
      }), "\n", _jsxs(_components.p, {
        children: ["If a tag group has ", _jsx(_components.strong, {
          children: "Allow these tags to be set only from your server"
        }), " enabled, Airship requires the master secret to change its tags. Use Basic Authentication for syncs that write to those tag groups."]
      }), "\n", _jsx(_components.h3, {
        id: "bearer-authentication",
        children: "Bearer Authentication"
      }), "\n", _jsxs(_components.p, {
        children: ["Create a token in Airship: select the dropdown menu next to your project name, then ", _jsx(_components.strong, {
          children: "Settings"
        }), ". Under ", _jsx(_components.strong, {
          children: "Project settings"
        }), ", select ", _jsx(_components.strong, {
          children: "Tokens"
        }), " > ", _jsx(_components.strong, {
          children: "Create token"
        }), ", enter a name, and select an access role. Airship shows the token only once, so copy it before you close the dialog."]
      }), "\n", _jsxs(_components.p, {
        children: ["Pick a role that covers every sync type the destination uses. Airship describes the roles in its ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/developer/rest-api/ua/api-security/#creating-bearer-tokens",
          children: "API security"
        }), " docs, and its ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/developer/rest-api/ua/api-auth-reference/",
          children: "API authorization reference"
        }), " shows which endpoints accept bearer tokens."]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Audience Modification"
          }), " grants read and write access to Airship's audience endpoints, and Airship lists sending custom events as its typical use. Use it for ", _jsx(_components.strong, {
            children: "Named Users"
          }), ", ", _jsx(_components.strong, {
            children: "Channels"
          }), ", ", _jsx(_components.strong, {
            children: "Subscription Lists"
          }), ", ", _jsx(_components.strong, {
            children: "Tags"
          }), ", ", _jsx(_components.strong, {
            children: "Static Lists"
          }), ", ", _jsx(_components.strong, {
            children: "Attribute Lists"
          }), ", and ", _jsx(_components.strong, {
            children: "Custom Events"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "All Access"
          }), " grants full access to the project. Use it for ", _jsx(_components.strong, {
            children: "Push Notification"
          }), " and ", _jsx(_components.strong, {
            children: "Templated Push"
          }), ", which send messages instead of changing audience data."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "Then enter these fields:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Access Token"
          }), ": the token you created."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "App key"
          }), ": the project's app key, which Airship shows alongside the token. Only ", _jsx(_components.strong, {
            children: "Custom Events"
          }), " syncs need it, because Airship's custom events API requires the app key in every request. The token and app key must belong to the same project."]
        }), "\n"]
      }), "\n", _jsx(Info, {
        children: _jsx(_components.p, {
          children: "Airship bearer tokens don't expire. To revoke Hightouch's access, delete the\ntoken in Airship."
        })
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsx(_components.h3, {
        id: "named-users",
        children: "Named Users"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the ", _jsx(_components.strong, {
          children: "Object"
        }), " sync type, then the ", _jsx(_components.strong, {
          children: "Named Users"
        }), " object, to set tags and attributes on named users. Use ", _jsx(_components.strong, {
          children: "Upsert"
        }), " when Hightouch should create named users that don't exist yet. Use ", _jsx(_components.strong, {
          children: "Update"
        }), " when Hightouch should only change existing named users. In ", _jsx(_components.strong, {
          children: "Update"
        }), " mode, Hightouch looks up each named user first and rejects rows Airship doesn't have."]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["Match rows to named users on ", _jsx(_components.strong, {
          children: "Named User ID"
        }), ". Airship named user IDs are case-sensitive, up to 128 characters, and can't have leading or trailing whitespace. See Airship's ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/guides/audience/named-users/",
          children: "named users"
        }), " docs."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mappings",
        children: "Field mappings"
      }), "\n", _jsx(_components.p, {
        children: "Map columns in three places:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Associate"
          }), ", in the field mappings: links channels or email addresses to the named user in the same request. Map a column that holds an array of objects, each with either ", _jsx(_components.code, {
            children: "email_address"
          }), ", or ", _jsx(_components.code, {
            children: "channel_id"
          }), " and optionally ", _jsx(_components.code, {
            children: "device_type"
          }), ". If a channel already belongs to another named user, Airship moves it to this one."]
        }), "\n", _jsxs(_components.li, {
          children: ["Attribute mappings: the dropdown lists Airship's ", _jsx(_components.a, {
            href: "https://www.airship.com/docs/reference/data-collection/attributes/",
            children: "default and predefined attributes"
          }), ". For a custom attribute, type its ", _jsx(_components.a, {
            href: "https://www.airship.com/docs/guides/audience/attributes/about/",
            children: "attribute ID"
          }), ", not its name. Except for default attributes, define every attribute in your Airship project first."]
        }), "\n", _jsxs(_components.li, {
          children: ["Tag mappings: on the right side of each tags mapping, enter the ", _jsx(_components.strong, {
            children: "Group Key"
          }), " of an existing, active ", _jsx(_components.a, {
            href: "https://www.airship.com/docs/guides/audience/tags/setting/#create-custom-tag-groups",
            children: "tag group"
          }), ". Each mapping replaces the tags in that group. See ", _jsx(_components.a, {
            href: "#behavior-and-limitations",
            children: "Behavior and limitations"
          }), "."]
        }), "\n"]
      }), "\n", "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["You can map ", _jsx(_components.code, {
            children: "string"
          }), " or ", _jsx(_components.code, {
            children: "array"
          }), " values to tags. If you provide a string,\nHightouch splits it on commas into an ", _jsx(_components.code, {
            children: "array"
          }), ". For example, Hightouch\ntransforms the string ", _jsx(_components.code, {
            children: "\"dogs, cats, parrots\""
          }), " into this array: ", _jsx(_components.code, {
            children: "[\"dogs\",   \"cats\", \"parrots\"]"
          }), "."]
        })
      }), "\n", "\n", _jsx(_components.h3, {
        id: "channels",
        children: "Channels"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the ", _jsx(_components.strong, {
          children: "Object"
        }), " sync type, then the ", _jsx(_components.strong, {
          children: "Channels"
        }), " object, to set tags and attributes on individual channels, such as a single app install or email address. Channels support ", _jsx(_components.strong, {
          children: "Update"
        }), " only, because Airship creates channels when devices and addresses register."]
      }), "\n", _jsxs(_components.p, {
        children: ["Prefer ", _jsx(_components.a, {
          href: "#named-users",
          children: "Named Users"
        }), " when you target people across devices. Airship applies a named user's tags to every channel associated with that named user, but channel tags stay on their channel."]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-1",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["Match rows on ", _jsx(_components.strong, {
          children: "Channel ID"
        }), ", the UUID Airship assigns to each channel. Hightouch updates channels by ID without looking them up first."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mappings-1",
        children: "Field mappings"
      }), "\n", _jsxs(_components.p, {
        children: ["Map ", _jsx(_components.strong, {
          children: "Device type"
        }), " for every row, from a column or as a static value. Accepted values are ", _jsx(_components.code, {
          children: "ios"
        }), ", ", _jsx(_components.code, {
          children: "android"
        }), ", ", _jsx(_components.code, {
          children: "amazon"
        }), ", ", _jsx(_components.code, {
          children: "web"
        }), ", ", _jsx(_components.code, {
          children: "email"
        }), ", and ", _jsx(_components.code, {
          children: "open"
        }), ". Case doesn't matter. Hightouch rejects rows with a missing or different device type. SMS channels aren't supported, because Airship's channel attributes API addresses them by phone number instead of channel ID."]
      }), "\n", _jsxs(_components.p, {
        children: ["Attributes and tags map the same way as for ", _jsx(_components.a, {
          href: "#named-users",
          children: "named users"
        }), ". Hightouch sends a row's tags and then its attributes in separate requests. If Airship skips a tag group, Hightouch rejects the row and doesn't send its attributes."]
      }), "\n", _jsx(_components.h3, {
        id: "send-push-notifications",
        children: "Send push notifications"
      }), "\n", _jsxs(_components.p, {
        children: ["Use ", _jsx(_components.strong, {
          children: "Push Notification"
        }), " to send a message to an Airship segment whenever a row is added to your model. Every push goes to the whole segment, not to a recipient in the row. To message individual named users, use ", _jsx(_components.a, {
          href: "#send-templated-pushes",
          children: "Templated Push"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: "Configure the push:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Segment ID"
          }), ": select an Airship segment or enter its ID."]
        }), "\n", _jsxs(_components.li, {
          children: ["Device type: select one of ", _jsx(_components.strong, {
            children: "iOS"
          }), ", ", _jsx(_components.strong, {
            children: "Android"
          }), ", ", _jsx(_components.strong, {
            children: "Email"
          }), ", or ", _jsx(_components.strong, {
            children: "SMS"
          }), "."]
        }), "\n", _jsx(_components.li, {
          children: "Title and body: both support Liquid, so they can include values from the row that triggered the push. The email subject, HTML body, and plain text body support Liquid too, as do the content title and body of an iOS media attachment."
        }), "\n", _jsx(_components.li, {
          children: "Device-specific fields: an optional media attachment for iOS, extra key/value mappings for Android, or an expiry in seconds for SMS."
        }), "\n", _jsxs(_components.li, {
          children: ["Message type, for email: select ", _jsx(_components.strong, {
            children: "Commercial"
          }), " for promotional email and ", _jsx(_components.strong, {
            children: "Transactional"
          }), " for messages such as receipts and account updates. Commercial email only reaches opted-in addresses and must contain an unsubscribe link. See Airship's ", _jsx(_components.a, {
            href: "https://www.airship.com/docs/developer/api-integrations/email/commercial-transactional/",
            children: "commercial vs. transactional"
          }), " docs."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch sends nothing on the initial sync run or on a ", _jsx(_components.a, {
          href: "/syncs/overview#resync-full-query",
          children: "full resync"
        }), ", so the rows already in your model don't each trigger a push."]
      }), "\n", _jsx(_components.h3, {
        id: "subscription-lists",
        children: "Subscription Lists"
      }), "\n", _jsxs(_components.p, {
        children: ["Use ", _jsx(_components.strong, {
          children: "Subscription Lists"
        }), " to subscribe named users to Airship subscription lists when they enter your model and unsubscribe them when they leave. Match rows on ", _jsx(_components.strong, {
          children: "Named User ID"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: "Select one or more existing lists, or map a column that contains the list IDs. If your credentials aren't allowed to list subscription lists, none appear in the dropdown, so map a column instead."
      }), "\n", _jsx(_components.h4, {
        id: "field-mappings-2",
        children: "Field mappings"
      }), "\n", _jsxs(_components.p, {
        children: ["Airship requires ", _jsx(_components.strong, {
          children: "Scopes"
        }), ", the channel types the subscription applies to. Map an array or a comma-separated string of ", _jsx(_components.code, {
          children: "app"
        }), ", ", _jsx(_components.code, {
          children: "web"
        }), ", ", _jsx(_components.code, {
          children: "email"
        }), ", and ", _jsx(_components.code, {
          children: "sms"
        }), ". See Airship's ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/developer/rest-api/ua/operations/named-users/#performnameduserscopedbatchoperations",
          children: "scoped named user operations"
        }), " docs."]
      }), "\n", _jsx(_components.h3, {
        id: "send-templated-pushes",
        children: "Send templated pushes"
      }), "\n", _jsxs(_components.p, {
        children: ["Use ", _jsx(_components.strong, {
          children: "Templated Push"
        }), " to send an Airship app content template to each named user who enters your model. Each new row sends one push to that named user's devices. Rows that change or leave the model send nothing. Match rows on ", _jsx(_components.strong, {
          children: "Named User ID"
        }), "."]
      }), "\n", _jsx(EventSyncWarning, {
        type: "push"
      }), "\n", _jsx(_components.p, {
        children: "Configure the push:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Device types: select any combination of ", _jsx(_components.strong, {
            children: "iOS"
          }), ", ", _jsx(_components.strong, {
            children: "Android"
          }), ", and ", _jsx(_components.strong, {
            children: "Amazon (Fire OS)"
          }), ". The default is iOS and Android. Web, email, and SMS need other template types, so they aren't available."]
        }), "\n", _jsx(_components.li, {
          children: "Template: with Basic Authentication, select an app content template or enter its ID. With Bearer Authentication, enter the template ID, because Airship doesn't let bearer tokens list templates. To send different templates per row, map a column of template IDs."
        }), "\n", _jsxs(_components.li, {
          children: ["Personalization: each mapped column becomes a ", _jsx(_components.a, {
            href: "https://www.airship.com/docs/developer/rest-api/ua/schemas/push/#pushobject",
            children: "global attribute"
          }), " that the template reads by name. To send a set of values in one mapping, map an object column to ", _jsx(_components.strong, {
            children: "Global attributes"
          }), ". Names must start with a letter and can't start with ", _jsx(_components.code, {
            children: "ua_"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["To find a template's ID in Airship, go to ", _jsx(_components.strong, {
          children: "Content"
        }), " > ", _jsx(_components.strong, {
          children: "Templates"
        }), ", open the template's menu, and select ", _jsx(_components.strong, {
          children: "Copy ID to clipboard"
        }), ". See Airship's ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/guides/personalization/content/templates/",
          children: "content templates"
        }), " docs to create one."]
      }), "\n", _jsxs(_components.p, {
        children: ["The form also has optional campaign categories and delivery settings. See Airship's ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/developer/rest-api/ua/schemas/push/#pushobject",
          children: "push object"
        }), " docs for what each does."]
      }), "\n", _jsx(_components.h4, {
        id: "configure-initial-pushes",
        children: "Configure initial pushes"
      }), "\n", _jsxs(_components.p, {
        children: ["By default, the initial sync run and a ", _jsx(_components.a, {
          href: "/syncs/overview#resync-full-query",
          children: "full resync"
        }), " send no pushes, so named users already in your model don't each get one. Select ", _jsx(_components.strong, {
          children: "No, send a push for every row"
        }), " only if every named user in the model should get the push on the first run."]
      }), "\n", _jsx(_components.h3, {
        id: "tags",
        children: "Tags"
      }), "\n", _jsxs(_components.p, {
        children: ["Use ", _jsx(_components.strong, {
          children: "Tags"
        }), " to keep one Airship tag in step with model membership. Named users get the tag when they enter your model and lose it when they leave. Hightouch doesn't change other tags, including others in the same tag group. Match rows on ", _jsx(_components.strong, {
          children: "Named User ID"
        }), ". Airship ignores named user IDs it doesn't have."]
      }), "\n", _jsx(_components.p, {
        children: "Configure the tag:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Tag group: enter the ", _jsx(_components.strong, {
            children: "Group Key"
          }), " of an active tag group, not its display name. Create tag groups in Airship under ", _jsx(_components.strong, {
            children: "Audience"
          }), " > ", _jsx(_components.strong, {
            children: "Tags"
          }), " > ", _jsx(_components.strong, {
            children: "Tag Groups"
          }), ". Airship reserves keys that start with ", _jsx(_components.code, {
            children: "ua_"
          }), "."]
        }), "\n", _jsx(_components.li, {
          children: "Tag: enter the tag that members of the model should have, up to 128 characters. Tags are case-sensitive. Airship creates the tag the first time Hightouch sets it."
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Each sync manages one tag. To manage more than one tag, create a sync for each. See Airship's ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/guides/audience/tags/setting/",
          children: "tags"
        }), " docs for tag group setup and limits."]
      }), "\n", _jsx(_components.h3, {
        id: "static-lists",
        children: "Static Lists"
      }), "\n", _jsxs(_components.p, {
        children: ["Use ", _jsx(_components.strong, {
          children: "Static Lists"
        }), " to replace an Airship static list with the named users in your model on every sync run. Airship's dashboard calls static lists uploaded lists. Named users who leave your model drop off the list on the next run. Match rows on ", _jsx(_components.strong, {
          children: "Named User ID"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Select ", _jsx(_components.strong, {
          children: "Use an existing static list"
        }), " and select or enter its name. If your credentials aren't allowed to list static lists, none appear in the dropdown, so type the name instead."]
      }), "\n", _jsxs(_components.p, {
        children: ["Or select ", _jsx(_components.strong, {
          children: "Create a new static list"
        }), ", and Hightouch creates it on the first sync run. Leave the name blank to use your model's name. Hightouch replaces characters other than letters, numbers, ", _jsx(_components.code, {
          children: "."
        }), ", ", _jsx(_components.code, {
          children: "_"
        }), ", ", _jsx(_components.code, {
          children: "~"
        }), ", and ", _jsx(_components.code, {
          children: "-"
        }), " with underscores and shortens the name to 64 characters."]
      }), "\n", _jsx(Info, {
        children: _jsx(_components.p, {
          children: "Airship deletes a static list after 90 days without an upload or a send.\nSchedule the sync to run at least once every 90 days to keep the list."
        })
      }), "\n", _jsx(_components.h3, {
        id: "custom-events",
        children: "Custom Events"
      }), "\n", _jsxs(_components.p, {
        children: ["Use ", _jsx(_components.strong, {
          children: "Custom Events"
        }), " to send actions such as purchases to Airship, where they can trigger Automations and Sequences and personalize messages. Each row added to your model sends one event. Changed and removed rows send nothing."]
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Custom Events requires ", _jsx(_components.strong, {
            children: "Bearer Authentication"
          }), " with the ", _jsx(_components.strong, {
            children: "App key"
          }), " entered.\nOtherwise, the sync form shows a warning, and Hightouch sends no events."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-2",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["Match each event to a ", _jsx(_components.strong, {
          children: "Named User ID"
        }), ", which attributes it across every channel of the named user, or to a ", _jsx(_components.strong, {
          children: "Channel ID"
        }), ", which attributes it to one channel. Each channel ID must be a UUID. When you match on ", _jsx(_components.strong, {
          children: "Channel ID"
        }), ", you can map each channel's device type. If you leave it blank, Airship determines the device type from the channel ID."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mappings-3",
        children: "Field mappings"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Event name: select a column or enter a static value. Airship rejects event names with uppercase characters, so Hightouch converts names to lowercase before sending. Names can be up to 255 characters."
        }), "\n", _jsxs(_components.li, {
          children: ["Event fields: Hightouch rejects rows whose ", _jsx(_components.strong, {
            children: "Value"
          }), " isn't a number or whose ", _jsx(_components.strong, {
            children: "Session ID"
          }), " isn't a UUID. Set ", _jsx(_components.strong, {
            children: "Unique ID"
          }), " when event properties trigger or personalize a Sequence, so Airship doesn't drop the messages as duplicate sends."]
        }), "\n", _jsxs(_components.li, {
          children: ["Properties: map columns to property names, or map an object column to ", _jsx(_components.strong, {
            children: "Event properties"
          }), ". Individually mapped columns override keys of the same name in the object. See Airship's ", _jsx(_components.a, {
            href: "https://www.airship.com/docs/guides/personalization/sources/custom-events/",
            children: "custom event personalization"
          }), " docs."]
        }), "\n", _jsx(_components.li, {
          children: "Timestamp: optionally map a column with each event's time. If you leave it blank, or a row's timestamp is empty, Airship uses the time it receives the event. Airship only accepts events from the past 90 days and rejects future timestamps."
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "configure-the-event-backfill",
        children: "Configure the event backfill"
      }), "\n", _jsxs(_components.p, {
        children: ["By default, the initial sync run and a ", _jsx(_components.a, {
          href: "/syncs/overview#resync-full-query",
          children: "full resync"
        }), " send every row in your model as an event. A backfill can trigger Airship automations for every named user or channel in the model. Select ", _jsx(_components.strong, {
          children: "Yes, skip the backfill"
        }), " to send only rows added after the initial run."]
      }), "\n", _jsx(_components.h3, {
        id: "attribute-lists",
        children: "Attribute Lists"
      }), "\n", _jsxs(_components.p, {
        children: ["Use ", _jsx(_components.strong, {
          children: "Attribute Lists"
        }), " to set Text, Number, and Date attributes on the named users in your model by uploading the model to an Airship ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/guides/audience/attributes/setting/",
          children: "attribute list"
        }), ". Each sync run uploads every row, not only rows that changed, and Airship sets the attributes in the background. Match rows on ", _jsx(_components.strong, {
          children: "Named User ID"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch sends nothing for named users who leave your model, so they keep their attributes. To set attributes only on rows that change, use ", _jsx(_components.a, {
          href: "#named-users",
          children: "Named Users"
        }), " instead."]
      }), "\n", _jsxs(_components.p, {
        children: ["Select ", _jsx(_components.strong, {
          children: "Use an existing attribute list"
        }), " and select or enter its name. Airship only lets Hightouch upload to lists whose names start with ", _jsx(_components.code, {
          children: "ua_attributes_"
        }), ". A list appears in the dropdown only after its first upload, and none appear if your credentials aren't allowed to list attribute lists. In either case, type the name instead."]
      }), "\n", _jsxs(_components.p, {
        children: ["Or select ", _jsx(_components.strong, {
          children: "Create a new attribute list"
        }), ", and Hightouch creates it on the first sync run. Leave the name blank to use your model's name. Enter the name without the ", _jsx(_components.code, {
          children: "ua_attributes_"
        }), " prefix, because Hightouch adds the prefix Airship requires. Hightouch also replaces characters other than letters, numbers, ", _jsx(_components.code, {
          children: "."
        }), ", ", _jsx(_components.code, {
          children: "_"
        }), ", ", _jsx(_components.code, {
          children: "~"
        }), ", and ", _jsx(_components.code, {
          children: "-"
        }), " with underscores, and shortens the full name to 64 characters. If Airship already has a list with that name, the sync run fails, so select that list as an existing list or enter a different name."]
      }), "\n", _jsxs(_components.p, {
        children: ["What an empty cell does depends on the list's name. Hightouch sends null and empty values as empty cells, and Airship leaves those attributes unchanged. In a snapshot list, whose name starts with ", _jsx(_components.code, {
          children: "ua_attributes_snapshot_"
        }), ", Airship removes them instead. To clear attributes with empty values, select an existing snapshot list, or create a new list whose name starts with ", _jsx(_components.code, {
          children: "snapshot_"
        }), "."]
      }), "\n", _jsx(Info, {
        children: _jsx(_components.p, {
          children: "Airship deletes an attribute list 90 days after its last upload, but keeps the\nattributes it set. Schedule the sync to run at least once every 90 days to\nkeep the list. A run with an empty model uploads nothing, so it doesn't reset\nthe 90 days. After Airship deletes the list, runs fail until you select\nanother list or create a new one."
        })
      }), "\n", _jsx(_components.h4, {
        id: "field-mappings-4",
        children: "Field mappings"
      }), "\n", _jsxs(_components.p, {
        children: ["Map up to 100 columns to Text, Number, or Date attributes. Create each attribute in your Airship project first, including predefined attributes. After you create an attribute, wait at least 10 minutes before a sync run sets it, because Airship needs that time to process a new attribute. The dropdown lists Airship's ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/reference/data-collection/attributes/",
          children: "predefined attributes"
        }), ". For a custom attribute, type its ", _jsx(_components.a, {
          href: "https://www.airship.com/docs/guides/audience/attributes/about/",
          children: "attribute ID"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Airship has no Boolean attribute type, so map boolean columns only to Text attributes. Hightouch writes them as ", _jsx(_components.code, {
          children: "true"
        }), " and ", _jsx(_components.code, {
          children: "false"
        }), ". Text attribute values can be up to 255 characters, and Hightouch doesn't check their length before uploading. Attribute lists can't set JSON attributes, so Hightouch leaves out rows with an object or array value."]
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch converts any value in ", _jsx(_components.code, {
          children: "YYYY-MM-DD"
        }), " form, or an ISO 8601 timestamp with a time zone, to ", _jsx(_components.code, {
          children: "YYYY-MM-DDTHH:MM:SS"
        }), " in UTC. It converts these values for every attribute, including Text attributes. A date-only value such as ", _jsx(_components.code, {
          children: "2024-03-15"
        }), " becomes midnight UTC. Hightouch sends dates in other formats unchanged, and Airship fails Date attribute values it can't parse while processing the upload."]
      }), "\n", _jsx(_components.h3, {
        id: "event-streaming",
        children: "Event streaming"
      }), "\n", _jsxs(_components.p, {
        children: ["You can use Airship as an ", _jsx(_components.a, {
          href: "/events/event-streaming",
          children: "event streaming"
        }), " destination with every sync type except ", _jsx(_components.strong, {
          children: "Push Notification"
        }), ", ", _jsx(_components.strong, {
          children: "Static Lists"
        }), ", and ", _jsx(_components.strong, {
          children: "Attribute Lists"
        }), ". ", _jsx(_components.strong, {
          children: "Push Notification"
        }), " would message its whole segment once per event, and ", _jsx(_components.strong, {
          children: "Static Lists"
        }), " and ", _jsx(_components.strong, {
          children: "Attribute Lists"
        }), " only upload a whole model at a time."]
      }), "\n", _jsx(_components.p, {
        children: "Hightouch handles each streamed event like a row added to a model:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Tags"
          }), " only adds the tag, and ", _jsx(_components.strong, {
            children: "Subscription Lists"
          }), " only subscribes. Streaming never removes a tag or unsubscribes a named user."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Templated Push"
          }), " sends a push for every matching event. The initial sync run setting has no effect."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Custom Events"
          }), " still requires Bearer Authentication with the ", _jsx(_components.strong, {
            children: "App key"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["For Hightouch platform error codes related to Airship, see ", _jsx(_components.a, {
            href: "/developer-tools/error-codes#other-destinations",
            children: "Error codes: other\ndestinations"
          }), "."]
        })
      }), "\n", _jsx(_components.h3, {
        id: "behavior-and-limitations",
        children: "Behavior and limitations"
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Tag mappings replace each mapped tag group."
        }), " Named Users and Channels syncs set the full list of tags in every mapped tag group, so Airship removes tags in that group that aren't in the row. Tag groups you don't map stay as they are. To add or remove one tag without touching the rest of its group, use the ", _jsx(_components.a, {
          href: "#tags",
          children: "Tags"
        }), " sync type."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Empty cells don't clear values."
        }), " In Named Users and Channels syncs, an empty tag cell leaves its tag group unchanged, and an empty attribute cell leaves the attribute unchanged. These syncs can't clear a tag group or remove an attribute."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Airship can apply part of a row."
        }), " When Airship skips a tag group or attribute, it still applies the rest of the request. For example, it skips a tag group that doesn't exist or an attribute that isn't defined in the project. Hightouch then rejects the row with Airship's warning, such as ", _jsx(_components.code, {
          children: "Airship did not apply tags: The following tag groups do not exist: loyalty"
        }), ". The row's other tags and attributes may already be in Airship."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Date attributes need a time."
        }), " Airship parses date attributes as ", _jsx(_components.code, {
          children: "YYYY-MM-DDTHH:MM:SS"
        }), ", and Hightouch converts timestamp values to that format in UTC. In Named Users and Channels syncs, it converts date-only values, such as ", _jsx(_components.code, {
          children: "2024-03-15"
        }), ", only for the predefined ", _jsx(_components.code, {
          children: "birthdate"
        }), " and ", _jsx(_components.code, {
          children: "account_creation"
        }), " attributes. For custom date attributes in those syncs, cast date columns to timestamps in your model. Attribute Lists syncs convert date-only values for every attribute."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Changing a Tags sync's tag doesn't move existing members."
        }), " If you change the tag or tag group, named users who already have the old tag keep it, and later removals take off the new tag. To switch tags, create a new sync and remove the old tag in Airship."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Static list uploads process in the background."
        }), " A sync run succeeds once Airship accepts the upload. Airship keeps sending to the previous version of the list until the new version finishes processing. Hightouch doesn't report processing failures, so check the list's status in Airship as described in ", _jsx(_components.a, {
          href: "#validate-your-setup",
          children: "Validate your setup"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "An empty model doesn't empty a static list."
        }), " If no row in your model has a usable named user ID, the run fails instead of emptying the list. Hightouch leaves rows without a usable named user ID out of the upload and doesn't report them as rejected. A static list can hold up to 10 million named users."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Attribute list uploads process in the background."
        }), " A sync run succeeds once Airship accepts the upload, and Airship then sets the attributes. Hightouch doesn't report values Airship fails to set while processing, so check the upload's status in Airship as described in ", _jsx(_components.a, {
          href: "#validate-your-setup",
          children: "Validate your setup"
        }), ". If a mapped attribute doesn't exist in the project, Airship rejects the whole upload, and every run fails until you create the attribute and wait at least 10 minutes, or remove the mapping. If a run starts while Airship is still processing the list's previous upload, Airship refuses the new upload. Hightouch retries for about five minutes and then fails the run, so space runs far enough apart for Airship to finish processing."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "Attribute list syncs leave out rows they can't upload."
        }), " Hightouch leaves out rows without a usable named user ID, or with a date Hightouch can't parse, an object, or an array. The run counts those rows as synced and doesn't report them as rejected. If your model has rows but Hightouch can't upload any of them, the run fails. An empty model uploads nothing, so it changes no attributes, even in a snapshot list. Airship accepts up to 10 million rows in an attribute list. Hightouch doesn't check that limit before uploading, so split a larger model across syncs that each upload to their own list."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "One invalid item doesn't fail a whole batch."
        }), " Airship rejects a whole Templated Push, Tags, or Custom Events request when one item is invalid. Hightouch splits the batch to isolate the invalid row and rejects only that row with Airship's error."]
      }), "\n", _jsx(_components.h3, {
        id: "validate-your-setup",
        children: "Validate your setup"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Named users and channels"
          }), ": in Airship, go to ", _jsx(_components.strong, {
            children: "Audience"
          }), " > ", _jsx(_components.strong, {
            children: "Contact Management"
          }), " and look up a named user ID or channel ID. The details show tag groups and attributes, and a named user's message history lists the messages Airship sent them in the last 30 days. See Airship's ", _jsx(_components.a, {
            href: "https://www.airship.com/docs/guides/audience/tools/contact-management/",
            children: "contact management"
          }), " docs."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Static lists"
          }), ": go to ", _jsx(_components.strong, {
            children: "Audience"
          }), " > ", _jsx(_components.strong, {
            children: "Lists"
          }), " > ", _jsx(_components.strong, {
            children: "Uploaded"
          }), ". A new upload shows ", _jsx(_components.strong, {
            children: "Processing"
          }), " until Airship finishes it, then ", _jsx(_components.strong, {
            children: "Ready"
          }), " or ", _jsx(_components.strong, {
            children: "Failed"
          }), ". See Airship's ", _jsx(_components.a, {
            href: "https://www.airship.com/docs/guides/audience/audience-lists/uploaded/",
            children: "uploaded lists"
          }), " docs."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Attribute lists"
          }), ": go to ", _jsx(_components.strong, {
            children: "Audience"
          }), " > ", _jsx(_components.strong, {
            children: "Attributes"
          }), " > ", _jsx(_components.strong, {
            children: "Upload History"
          }), " to see each upload's status. For an upload that shows ", _jsx(_components.strong, {
            children: "Processed with errors"
          }), ", download the error file to see which named users failed and why. Then look up a named user from your model in ", _jsx(_components.strong, {
            children: "Audience"
          }), " > ", _jsx(_components.strong, {
            children: "Contact Management"
          }), " and check its attributes. See Airship's ", _jsx(_components.a, {
            href: "https://www.airship.com/docs/guides/audience/attributes/adding/#view-upload-history",
            children: "upload history"
          }), " docs."]
        }), "\n"]
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(NoCommonErrors, {}), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
